export default function getCsrfToken(): string | null {
  const csrfTokenNode = document.querySelector("meta[name='csrf-token']");
  return csrfTokenNode && csrfTokenNode.getAttribute('content');
}
